/* eslint-disable*/
import {
  Box,
  Dialog,
  IconButton,
  Typography,
  Rating,
  CircularProgress
} from '@material-ui/core';
import React, { useState, useMemo } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux';
import {
  performanceModalOpen,
  performancereviewAmazonOtherReviewResult,
  performancereviewAmazonOwnReviewResult,
  performancereviewOtherDataLoading,
  performancereviewOwnDataLoading,
  performancereviewRakutenOtherReviewResult,
  performancereviewRakutenOwnReviewResult,
  setPerformanceModalOpen,
  performancereviewAmazonOwnItemData,
  performancereviewRakutenOwnItemData,
  performancereviewAmazonOtherItemData,
  performancereviewRakutenOtherItemData
} from 'feactures/performancereview/performancereviewSlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import theme from 'theme';
import PerformancePullDown from 'components/atoms/button/PerformancePullDown';
import OKicon from 'components/atoms/icon/OKicon';
import NGicon from 'components/atoms/icon/NGicon';
import { Divider } from '@mui/material';
import NavigationDialog from './NavigationDialog';

export const BoxContent = (props) => {
  const {
    koumokuName,
    data,
    sectionName,
    result,
    reason,
    groupName,
    category,
    itemData
  } = props;
  return (
    <Box>
      <Box display="flex" flexDirection="column">
        <Box display="flex" alignItems="center" columnGap="7px">
          <Typography
            fontWeight="bold"
            fontSize="15px"
            color={
              sectionName == '自社'
                ? theme.palette.text.main
                : theme.palette.text.secondary
            }
          >
            ✓{sectionName}
          </Typography>
          {!itemData?.selectItemFlag && (
            <Typography fontSize="12px">※商品を選択してください</Typography>
          )}
          {!data && itemData?.selectItemFlag && (
            <Typography
              fontSize="12px"
              color="error"
              sx={{ whiteSpace: 'pre-line' }}
            >
              {koumokuName == '商品説明' &&
                '※商品に説明文が設定されていない、または説明文の取得に失敗している為表示ができませんでした。\n詳細はOxcimサポートまでご連絡下さい。'}
              {koumokuName == 'タイトル' &&
                '※商品タイトルの取得に失敗している為表示ができませんでした。\n詳細はOxcimサポートまでご連絡下さい。'}
            </Typography>
          )}
        </Box>
        <Box gap={1} display="flex" flexDirection="column" px={2} mt={1}>
          {category && (
            <Box display="flex">
              <Typography fontWeight="bold" display="block" flexShrink={0}>
                カテゴリ：
              </Typography>
              <Typography ml={1}>{category}</Typography>
            </Box>
          )}
          {groupName &&
            !['集客', '出品'].some((word) => groupName.includes(word)) && (
              <>
                <Box alignItems="baseline" display="flex">
                  <Typography fontWeight="bold" display="inline" flexShrink={0}>
                    {koumokuName}：
                  </Typography>
                  {koumokuName == 'レビュー評価' ? (
                    <>
                      <Box display="flex" alignItems="baseline" gap={1} ml={2}>
                        <Typography fontSize="16px" fontWeight="bold">
                          {data}
                        </Typography>
                        <Box alignItems="baseline">
                          <Rating
                            value={data}
                            readOnly
                            sx={{
                              fontSize: '16px',
                              display: 'inline-flex',
                              alignItems: 'baseline',
                              verticalAlign: 'sub',
                              lineHeight: '0',
                              marginBottom: '-2px'
                            }}
                          />
                        </Box>
                      </Box>
                    </>
                  ) : koumokuName == 'レビュー数' ? (
                    <Typography
                      fontSize="14px"
                      color="#ffab40"
                      fontWeight="bold"
                      ml={1}
                    >
                      {data}
                    </Typography>
                  ) : groupName.includes('価格') ? (
                    <Typography fontSize="16px" ml={1}>
                      {data != null && data != 0
                        ? `¥${data.toLocaleString()}`
                        : '-'}
                    </Typography>
                  ) : (
                    <Typography display="inline" ml={1}>
                      {!data && data !== 0
                        ? '-'
                        : koumokuName === 'ランキング'
                        ? data === 0
                          ? '圏外'
                          : `${data}位`
                        : data}
                    </Typography>
                  )}
                </Box>
              </>
            )}
          {koumokuName == '閲覧数' && (
            <>
              <Box display="flex">
                <Typography fontWeight="bold" flexShrink={0}>
                  TOP商品の閲覧数：
                </Typography>
                <Typography ml={1}>{itemData.top1ClickNum}</Typography>
              </Box>
              <Box display="flex">
                <Typography fontWeight="bold" flexShrink={0}>
                  TOP商品に対する閲覧数の割合：
                </Typography>
                <Typography ml={1}>
                  {itemData.clickShareVsTop1 != null &&
                  itemData.clickShareVsTop1 !== 0
                    ? `${itemData.clickShareVsTop1}%`
                    : '-'}
                </Typography>
              </Box>
            </>
          )}

          <Box display="flex">
            <Typography
              fontWeight="bold"
              display="inline"
              variant="body1"
              flexShrink={0}
            >
              診断結果：
            </Typography>
            {(result || result === 0) && result !== '-' ? (
              result ? (
                <OKicon
                  sx={{
                    mr: 0,
                    fontSize: '18px',
                    verticalAlign: 'middle'
                  }}
                />
              ) : (
                <NGicon
                  sx={{
                    mr: 0,
                    fontSize: '18px',
                    verticalAlign: 'middle'
                  }}
                />
              )
            ) : (
              <Typography fontSize="16px" ml={1}>
                -
              </Typography>
            )}
            <Typography color="text.secondary" display="inline" ml={1}>
              {reason}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const CategoryBox = (props) => {
  const {
    groupName,
    ownData,
    otherData,
    ownResult,
    otherResult,
    koumokuName,
    ownReason,
    otherReason,
    ownItem,
    otherItem
  } = props;
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="start"
        width="100%"
        mt={2}
        mb={2}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pt={2}
        >
          <Typography
            color={'subText.dark'}
            fontSize="18px"
            fontWeight="bold"
            display="inline"
            flexShrink={0}
          >
            <span>
              <span style={{ fontSize: '0.85em', color: '#666' }}>
                カテゴリ：
                {ownData.categoryName ? ownData.categoryName : '-'}
              </span>
            </span>
          </Typography>
        </Box>
        <BoxContent
          groupName={groupName}
          sectionName="自社"
          koumokuName={koumokuName}
          result={ownResult}
          reason={ownReason}
          itemData={ownItem}
        />
        <Divider
          flexItem
          sx={{
            borderBottomWidth: 2,
            borderColor: 'secondary',
            mt: '20px',
            mb: '10px'
          }}
        />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pt={2}
        >
          <Typography
            color={'subText.dark'}
            fontSize="18px"
            fontWeight="bold"
            display="inline"
            flexShrink={0}
          >
            <span>
              <span style={{ fontSize: '0.85em', color: '#666' }}>
                カテゴリ：
                {otherData.categoryName ? otherData.categoryName : '-'}
              </span>
            </span>
          </Typography>
        </Box>
        <BoxContent
          groupName={groupName}
          sectionName="競合"
          koumokuName={koumokuName}
          result={otherResult}
          reason={otherReason}
          itemData={otherItem}
        />
      </Box>
    </>
  );
};

export const PriceBox = (props) => {
  const {
    detailsName,
    groupName,
    ownData,
    otherData,
    ownResult,
    otherResult,
    koumokuName,
    ownReason,
    otherReason,
    ownItem,
    otherItem
  } = props;
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="start"
        width="100%"
        mt={2}
        mb={2}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pt={2}
        >
          <Typography
            color={'subText.dark'}
            fontSize="18px"
            fontWeight="bold"
            display="inline"
            flexShrink={0}
          >
            {(() => {
              let label = '';
              let price = null;

              switch (detailsName) {
                case 'カテゴリ平均価格との競争力':
                  label = 'カテゴリ平均';
                  price = ownData.categoryAvgPrice;
                  break;
                case 'カテゴリTOP5商品との競争力':
                  label = 'カテゴリTOP5商品';
                  price = ownData.categoryTop5Price;
                  break;
                case 'カテゴリNo1商品との競争力':
                  label = 'カテゴリNo1商品';
                  price = ownData.categoryTop1Price;
                  break;
                default:
                  return '-'; // 該当しない場合は表示しない
              }

              return (
                <span>
                  {label}：{price ? `¥${price.toLocaleString()}` : '-'}
                  <span style={{ fontSize: '0.85em', color: '#666' }}>
                    {ownData.categoryName && `（${ownData.categoryName}）`}
                  </span>
                </span>
              );
            })()}
          </Typography>
        </Box>
        <BoxContent
          groupName={groupName}
          sectionName="自社"
          koumokuName={koumokuName}
          data={ownData.price}
          result={ownResult}
          reason={ownReason}
          itemData={ownItem}
        />
        <Divider
          flexItem
          sx={{
            borderBottomWidth: 2,
            borderColor: 'secondary',
            mt: '20px',
            mb: '10px'
          }}
        />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pt={2}
        >
          <Typography
            color={'subText.dark'}
            fontSize="18px"
            fontWeight="bold"
            display="inline"
            flexShrink={0}
          >
            {(() => {
              let label = '';
              let price = null;

              switch (detailsName) {
                case 'カテゴリ平均価格との競争力':
                  label = 'カテゴリ平均';
                  price = otherData.categoryAvgPrice;
                  break;
                case 'カテゴリTOP5商品との競争力':
                  label = 'カテゴリTOP5商品';
                  price = otherData.categoryTop5Price;
                  break;
                case 'カテゴリNo1商品との競争力':
                  label = 'カテゴリNo1商品';
                  price = otherData.categoryTop1Price;
                  break;
                default:
                  return '-'; // 該当しない場合は表示しない
              }

              return (
                <span>
                  {label}：{price ? `¥${price.toLocaleString()}` : '-'}{' '}
                  <span style={{ fontSize: '0.85em', color: '#666' }}>
                    {otherData.categoryName && `（${otherData.categoryName}）`}
                  </span>
                </span>
              );
            })()}
          </Typography>
        </Box>
        <BoxContent
          groupName={groupName}
          sectionName="競合"
          koumokuName={koumokuName}
          data={otherData.price}
          result={otherResult}
          reason={otherReason}
          itemData={otherItem}
        />
      </Box>
    </>
  );
};

export const BasicBox = (props) => {
  const {
    ownCategory,
    otherCategory,
    groupName,
    ownData,
    otherData,
    ownResult,
    otherResult,
    koumokuName,
    ownReason,
    otherReason,
    ownItem,
    otherItem
  } = props;
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="start"
        width="100%"
        mt={2}
        mb={2}
      >
        <BoxContent
          category={ownCategory}
          groupName={groupName}
          sectionName="自社"
          koumokuName={koumokuName}
          data={ownData}
          result={ownResult}
          reason={ownReason}
          itemData={ownItem}
        />
        <Divider
          flexItem
          sx={{
            borderBottomWidth: 2,
            borderColor: 'secondary',
            mt: '20px',
            mb: '10px'
          }}
        />
        <BoxContent
          category={otherCategory}
          groupName={groupName}
          sectionName="競合"
          koumokuName={koumokuName}
          data={otherData}
          result={otherResult}
          reason={otherReason}
          itemData={otherItem}
        />
      </Box>
    </>
  );
};

const ImgList = (props) => {
  const { imgList, sectionName, result, reason } = props;
  const url = 'https://m.media-amazon.com/images/I/';
  const [selectImg, setSelectImg] = useState(imgList[0]);

  return (
    <Box width="45%" height="100%" display="flex" flexDirection="column">
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <Box>
          <Typography fontWeight="bold" fontSize="15px">
            <span
              style={{ color: sectionName === '自社' ? '#718CC7' : 'inherit' }}
            >
              {sectionName}
            </span>
            <br />
            画像枚数：
            <span style={{ color: '#FFA500' }}>{imgList.length}</span>
          </Typography>

          {/* 診断結果（自社のみ表示） */}
          {
            <Box display="flex" alignItems="center" mt={1}>
              <Typography
                fontWeight="bold"
                fontSize="15px"
                variant="body1"
                flexShrink={0}
              >
                診断結果：
              </Typography>
              {result != '-' ? (
                result ? (
                  <OKicon
                    sx={{ mr: 0, fontSize: '18px', verticalAlign: 'middle' }}
                  />
                ) : (
                  <NGicon
                    sx={{ mr: 0, fontSize: '18px', verticalAlign: 'middle' }}
                  />
                )
              ) : (
                ''
              )}
              <Typography color="text.secondary" display="inline" ml={1}>
                {reason}
              </Typography>
            </Box>
          }
        </Box>

        {/* アイコン表示（result用） */}
      </Box>

      {/* 画像表示部分はそのまま */}
      {imgList.length > 0 ? (
        <Box display="flex" height="100%" gap={2} alignItems="start">
          {/* 画像一覧 */}
          <Box
            sx={{
              overflowY: 'auto', // スクロールを画像一覧のみに限定
              maxHeight: '60vh',
              padding: 1,
              width: '20%' // 全体の幅に応じてサイズ調整
            }}
          >
            {imgList.map((imgUrl, index) => (
              <Box
                key={index}
                mb={1}
                sx={{
                  border: 1,
                  borderColor: '#C3C3C3',
                  cursor: 'pointer'
                }}
                onClick={() => setSelectImg(imgUrl)}
              >
                <img
                  alt="item_img"
                  src={url + imgUrl}
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    aspectRatio: '1',
                    objectFit: 'contain'
                  }}
                />
              </Box>
            ))}
          </Box>

          {/* 選択した画像の表示 */}
          <Box
            sx={{
              width: '80%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img
              alt="item_img"
              src={url + selectImg}
              style={{
                display: 'inline-block',
                width: '90%',
                aspectRatio: '1',
                objectFit: 'contain'
              }}
            />
          </Box>
        </Box>
      ) : (
        <>
          <Typography color="text.secondary">
            画像のデータがありません
          </Typography>
        </>
      )}
    </Box>
  );
};
const ImgListBox = (props) => {
  const { ownData, otherData, ownResult, otherResult, ownReason, otherReason } =
    props;
  return (
    <Box
      display="flex"
      alignItems="start"
      justifyContent="space-around"
      gap={3}
    >
      <ImgList
        sectionName="自社"
        imgList={ownData}
        result={ownResult}
        reason={ownReason}
      />
      <ImgList
        sectionName="競合"
        imgList={otherData}
        result={otherResult}
        reason={otherReason}
      />
    </Box>
  );
};

const DetailAnalysisDialog = () => {
  const dispatch = useDispatch();
  const modalOpen = useSelector(performanceModalOpen);
  const channel = useSelector(currentchannel);
  const ownLoading = useSelector(performancereviewOwnDataLoading);
  const otherLoading = useSelector(performancereviewOtherDataLoading);
  const ownAmazonPerformanceDataList = useSelector(
    performancereviewAmazonOwnReviewResult
  );
  const otherAmazonPerformanceDataList = useSelector(
    performancereviewAmazonOtherReviewResult
  );
  const ownRakutenPerformanceDataList = useSelector(
    performancereviewRakutenOwnReviewResult
  );
  const otherRakutenPerformanceDataList = useSelector(
    performancereviewRakutenOtherReviewResult
  );

  const ownAmazonItem = useSelector(performancereviewAmazonOwnItemData);
  const otherAmazonItem = useSelector(performancereviewAmazonOtherItemData);
  const ownRakutenItem = useSelector(performancereviewRakutenOwnItemData);
  const otherRakutenItem = useSelector(performancereviewRakutenOtherItemData);

  // データ取得を関数化
  const getPerformanceData = (ownList, otherList, ownItem, otherItem) => {
    return {
      ownPerformanceData: ownList[modalOpen.index] || {},
      otherPerformanceData: otherList[modalOpen.index] || {},
      ownItemData: ownItem || {},
      otherItemData: otherItem || {}
    };
  };

  let ownPerformanceData = {};
  let otherPerformanceData = {};
  let ownItemData = {};
  let otherItemData = {};

  if (channel === 1) {
    ({ ownPerformanceData, otherPerformanceData, ownItemData, otherItemData } =
      getPerformanceData(
        ownAmazonPerformanceDataList,
        otherAmazonPerformanceDataList,
        ownAmazonItem,
        otherAmazonItem
      ));
  } else if (channel === 2) {
    ({ ownPerformanceData, otherPerformanceData, ownItemData, otherItemData } =
      getPerformanceData(
        ownRakutenPerformanceDataList,
        otherRakutenPerformanceDataList,
        ownRakutenItem,
        otherRakutenItem
      ));
  }

  const detailsIndex = modalOpen.detailsIndex;
  const details = ownPerformanceData?.details?.[detailsIndex] || {};
  const detailsName = details.name || '';

  const flags = useMemo(() => ({
    customerFlag: [
      'セール参加',
      'クーポン・割引の実施',
      'ポイント付与'
    ].includes(detailsName),
    priceFlag: [
      'カテゴリ平均価格との競争力',
      'カテゴリNo1商品との競争力',
      'カテゴリTOP5商品との競争力'
    ].includes(detailsName),
    reviewScoreFlag: detailsName === '適切なレビュー評価',
    reviewNumFlag: detailsName === '適切なレビュー件数',
    titleFlag: detailsName === 'タイトルの情報網羅',
    descriptionFlag: detailsName === '十分な商品説明',
    imgFlag: detailsName === '適切な商品画像',
    listingFlag: [
      '適切なカテゴリ登録',
      '即日配送',
      '送料無料',
      'プライムマーク',
      '在庫状況',
      'カート取得'
    ].includes(detailsName),
    rankingFlag: detailsName === '平均ランキング',
    viewNumFlag: detailsName === '十分な閲覧数'
  }));
  const dialogTitle = `${ownPerformanceData.name} > ${details.id} ${detailsName}`;
  const ownResult = details.evaluationFlag;
  const otherResult =
    otherPerformanceData?.details?.[detailsIndex]?.evaluationFlag;
  const ownReason = details.reason;
  const otherReason = otherPerformanceData?.details?.[detailsIndex]?.reason;
  const groupName = ownPerformanceData.name;
  const closeDialog = (event) => {
    event.stopPropagation();
    dispatch(
      setPerformanceModalOpen({ index: 0, open: false, detailsIndex: 0 })
    );
  };

  let comparePrice = '-';
  if (
    detailsName === 'カテゴリ平均価格との競争力' &&
    ownItemData.categoryAvgPrice != null
  ) {
    comparePrice = `¥${ownItemData.categoryAvgPrice.toLocaleString()}`;
  } else if (
    detailsName === 'カテゴリTOP5商品との競争力' &&
    ownItemData.categoryTop5Price != null
  ) {
    comparePrice = `¥${ownItemData.categoryTop5Price.toLocaleString()}`;
  } else if (
    detailsName === 'カテゴリNo1商品との競争力' &&
    ownItemData.categoryTop1Price != null
  ) {
    comparePrice = `¥${ownItemData.categoryTop1Price.toLocaleString()}`;
  }

  // 表示内容を関数化
  const renderContent = () => {
    if (ownLoading || otherLoading) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
          minHeight="300px"
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Box
        display="flex"
        alignItems="start"
        gap={3}
        sx={{ height: 'calc(100% - 50px)' }}
      >
        {flags.customerFlag && (
          <Box display="flex" flexDirection="column" width="100%">
            <BasicBox
              groupName={groupName}
              ownResult={ownResult}
              otherResult={otherResult}
              koumokuName={detailsName}
              ownReason={ownReason}
              otherReason={otherReason}
              ownItem={ownItemData}
              otherItem={otherItemData}
            />
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              pt={2}
            >
              <NavigationDialog
                path="/measureanalysis"
                page="measureanalysis"
              />
            </Box>
          </Box>
        )}
        {flags.priceFlag && (
          <Box display="flex" flexDirection="column" width="100%">
            <PriceBox
              detailsName={detailsName}
              groupName={groupName}
              ownData={ownItemData}
              otherData={otherItemData}
              ownResult={ownResult}
              otherResult={otherResult}
              koumokuName={'商品価格'}
              ownReason={ownReason}
              otherReason={otherReason}
              ownItem={ownItemData}
              otherItem={otherItemData}
            />
          </Box>
        )}
        {flags.reviewScoreFlag && (
          <BasicBox
            groupName={groupName}
            ownData={ownItemData.reviewScore}
            otherData={otherItemData.reviewScore}
            ownResult={ownResult}
            otherResult={otherResult}
            koumokuName={'レビュー評価'}
            ownReason={ownReason}
            otherReason={otherReason}
            ownItem={ownItemData}
            otherItem={otherItemData}
          />
        )}
        {flags.reviewNumFlag && (
          <BasicBox
            groupName={groupName}
            ownData={ownItemData.reviewNum}
            otherData={otherItemData.reviewNum}
            ownResult={ownResult}
            otherResult={otherResult}
            koumokuName={'レビュー数'}
            ownReason={ownReason}
            otherReason={otherReason}
            ownItem={ownItemData}
            otherItem={otherItemData}
          />
        )}
        {flags.titleFlag && (
          <BasicBox
            groupName={groupName}
            ownData={ownItemData.itemName}
            otherData={otherItemData.itemName}
            ownResult={ownResult}
            otherResult={otherResult}
            koumokuName={'タイトル'}
            ownReason={ownReason}
            otherReason={otherReason}
            ownItem={ownItemData}
            otherItem={otherItemData}
          />
        )}
        {flags.descriptionFlag && (
          <BasicBox
            groupName={groupName}
            ownData={ownItemData.description}
            otherData={otherItemData.description}
            ownResult={ownResult}
            otherResult={otherResult}
            koumokuName={'商品説明'}
            ownReason={ownReason}
            otherReason={otherReason}
            ownItem={ownItemData}
            otherItem={otherItemData}
          />
        )}
        {flags.imgFlag && (
          <ImgListBox
            groupName={groupName}
            ownData={ownItemData.imgList}
            otherData={otherItemData.imgList}
            ownResult={ownResult}
            otherResult={otherResult}
            ownReason={ownReason}
            otherReason={otherReason}
          />
        )}
        {flags.listingFlag && (
          <BasicBox
            ownCategory={
              detailsName == '適切なカテゴリ登録' && ownItemData.categoryName
            }
            otherCategory={
              detailsName == '適切なカテゴリ登録' && otherItemData.categoryName
            }
            groupName={groupName}
            ownResult={ownResult}
            otherResult={otherResult}
            ownReason={ownReason}
            otherReason={otherReason}
            ownItem={ownItemData}
            otherItem={otherItemData}
          />
        )}
        {flags.rankingFlag && (
          <BasicBox
            groupName={groupName}
            ownResult={ownResult}
            otherResult={otherResult}
            ownReason={ownReason}
            otherReason={otherReason}
            koumokuName={'ランキング'}
            ownData={ownItemData.aveRank}
            otherData={otherItemData.aveRank}
            ownItem={ownItemData}
            otherItem={otherItemData}
          />
        )}

        {flags.viewNumFlag && (
          <BasicBox
            groupName={groupName}
            ownCategory={ownItemData.categoryName}
            otherCategory={otherItemData.categoryName}
            ownData={ownItemData.viewNum}
            otherData={otherItemData.viewNum}
            ownResult={ownResult}
            otherResult={otherResult}
            koumokuName={'閲覧数'}
            ownReason={ownReason}
            otherReason={otherReason}
            ownItem={ownItemData}
            otherItem={otherItemData}
          />
        )}
      </Box>
    );
  };

  return (
    <Dialog
      open={modalOpen.open}
      onClose={closeDialog}
      onClick={(event) => event.stopPropagation()}
      maxWidth="lg"
      sx={{
        '& .MuiDialog-paper': {
          minWidth: '600px',
          maxHeight: '90vh',
          maxWidth: '80%'
        }
      }}
    >
      <Box p={3} minWidth="600px">
        <Box display="flex" flexDirection="column">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              fontWeight="bold"
              fontSize="14px"
              mb={2}
              color="text.main"
            >
              {dialogTitle}
            </Typography>
            <IconButton onClick={closeDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
          <PerformancePullDown graphLoading={ownLoading || otherLoading} />
        </Box>
        {renderContent()}
      </Box>
    </Dialog>
  );
};

export default DetailAnalysisDialog;
